exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-component='change-digital-signature'] .content {\n  -webkit-transform-origin: top;\n          transform-origin: top;\n}\n[data-component='change-digital-signature'] .steps-container {\n  width: 100%;\n  overflow: hidden;\n  position: relative;\n  margin: 0 0 40px;\n  min-height: 300px;\n  -webkit-perspective: 500px;\n          perspective: 500px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n[data-component='change-digital-signature'] .step {\n  top: 0;\n  left: 150%;\n  position: relative;\n  width: 100%;\n}\n[data-component='change-digital-signature'] [data-component='step-buttons'] {\n  position: relative;\n}\n[data-component='change-digital-signature'] [data-component='step-buttons'] .btn {\n  width: 200px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/change-digital-signature/change-digital-signature.component.styl
// module id = ../../../../../src/app/master/change-digital-signature/change-digital-signature.component.styl
// module chunks = main